import colors from 'vuetify/lib/util/colors'

const commonColours = {
  black: '#353839',
  error: '#B71C1C',
  info: '#01579B',
  grey: {
    ...colors.grey
  }
}

export function clientTheme({ clientContext }) {
  const primaryColor = clientContext.primaryColor // '#FC8049' // clientContext.primaryColor

  // Convert HEX to RGB
  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '')
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)
    return `${r}, ${g}, ${b}` // Return as "R, G, B"
  }

  const rgbPrimary = hexToRgb(primaryColor)

  const themeConfig = {
    locales: clientContext.languages.map(({ iso }) => iso),
    light: {
      primary: primaryColor,
      ...commonColours
    }
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    document.documentElement.style.setProperty('--custom-primary', primaryColor)
    document.documentElement.style.setProperty('--custom-primary-rgb', rgbPrimary) // Store RGB version
  }

  return themeConfig
}
